import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ClientSidebar from '../../components/ClientSidebar';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { useAuth } from '../../context/AuthContext';
import { loanService } from '../../services/api';
import {
  CheckCircle,
  AlertCircle
} from 'lucide-react';

const FinanceProject = () => {
  const { user } = useAuth();
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.id) {
      loadLoans();
    }
  }, [user]);

  const loadLoans = async () => {
    try {
      const data = await loanService.getByClient(user.id);
      setLoans(data);
    } catch (error) {
      console.error('Error loading loans:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <ClientSidebar />
      <div className="flex-1 bg-gray-50">
        {/* Header */}
        <div className="bg-gray-800 text-white py-3 px-8 text-sm">
          Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
        </div>

        {/* Main Content */}
        <div className="max-w-6xl mx-auto p-8">
          {/* Tabs */}
          <Tabs defaultValue="contracts" className="space-y-6">
            <TabsList className="bg-gradient-to-r from-teal-500 to-cyan-500 text-white w-full justify-start rounded-none p-0 h-auto">
              <TabsTrigger
                value="contracts"
                className="data-[state=active]:bg-white data-[state=active]:text-purple-700 rounded-none px-6 py-3 text-white data-[state=active]:font-semibold"
              >
                Vos contrats Younited
              </TabsTrigger>
              <TabsTrigger
                value="credit"
                className="data-[state=active]:bg-white data-[state=active]:text-purple-700 rounded-none px-6 py-3 text-white data-[state=active]:font-semibold"
              >
                Vente à Crédit
              </TabsTrigger>
            </TabsList>

            <TabsContent value="contracts">
              {/* App Promotion Banner */}
              <Card className="p-6 mb-6 border-0" style={{ backgroundColor: '#8B5CF6' }}>
                <div className="flex items-center justify-between text-white">
                  <div className="flex-1 pr-6">
                    <h3 className="font-bold text-xl mb-3">
                      Gardez le contrôle sur votre budget avec l'app Younited !
                    </h3>
                    <p className="text-sm mb-3 text-white/95">
                      Grâce à la nouvelle fonctionnalité <strong>Alerte compte courant</strong> exclusive de l'application Younited,
                      gardez le contrôle sur le solde de vos comptes bancaires et soyez alerté en cas de solde bas.
                    </p>
                    <p className="text-sm font-semibold">Téléchargez l'app maintenant !</p>
                  </div>
                  <div>
                    <div className="bg-white/10 p-3 rounded-lg backdrop-blur-sm">
                      <img
                        src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=200&h=300&fit=crop"
                        alt="Mobile app"
                        className="w-28 h-44 object-cover rounded-lg shadow-xl"
                      />
                    </div>
                  </div>
                </div>
              </Card>

              {/* Info message */}
              <Card className="p-6 text-center">
                <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-4" />
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Consultez votre demande de prêt</h3>
                <p className="text-gray-600 mb-4">
                  Le suivi de votre demande de crédit est disponible sur votre tableau de bord principal.
                </p>
                <Link to="/client/dashboard">
                  <Button
                    className="text-white"
                    style={{ backgroundColor: '#8B5CF6' }}
                  >
                    Voir mon tableau de bord
                  </Button>
                </Link>
              </Card>
            </TabsContent>

            <TabsContent value="credit">
              <div className="text-center py-16">
                <AlertCircle className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-600 text-lg">Aucune demande en cours</p>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default FinanceProject;
